import React from 'react';
import LearningCard from '../components/LearningCard';

const VillageBike = () => (
  <LearningCard
    testid="villagebike"
    title="Village Bike"
    subtitle="Handleiding en quick start"
    support="Open hier de Nederlandstalige video handleiding voor het correct opzetten en gebruiken van de Village Bike."
    buttons={[
      {
        label: 'Open de handleiding',
        href: 'https://app.qoldo.com/p/0ecba469-5bee-474d-80f8-72aeab98d781?t=ec0f3d8f-d970-4724-9e7a-ff6cc0359be8',
        testid: 'btn-open-handleiding',
      },
    ]}
  />
);

export default VillageBike;
